import React from 'react'
import {toMessageList} from '../lib/apiErrors'

export default ({errors}) => {
  const messages = toMessageList(errors)

  if(messages.length == 0) {
    return null
  }

  return (
    <ul>
      {messages.map((item, i) =>
        <li className="error" key={i}>{item}</li>
      )}
    </ul>
  )
}
